/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Pauze_ToevoegenInputs */

const nl_planning_rooster_pauze_toevoegen = /** @type {(inputs: Planning_Rooster_Pauze_ToevoegenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze`)
};

/**

* @param {Planning_Rooster_Pauze_ToevoegenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_toevoegen = /** @type {((inputs?: Planning_Rooster_Pauze_ToevoegenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_ToevoegenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_toevoegen(inputs)
});
export { planning_rooster_pauze_toevoegen as "planning.rooster.pauze_toevoegen" }